import React from 'react';
import { Heart, Clock, Award } from 'lucide-react';

const Attention = () => {
  return (
    <section className="py-20 bg-[#C1272D] text-white relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-2xl shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1681270543584-8e541a1bb056?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxjaGVmJTIwY29va2luZ3xlbnwwfHx8fDE3NzYyMDM3MDJ8MA&ixlib=rb-4.1.0&q=85"
                alt="Chef profesional"
                className="w-full h-[500px] object-cover"
              />
            </div>
          </div>

          {/* Content */}
          <div>
            <h2
              className="text-4xl md:text-5xl font-bold mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Atención que Marca la Diferencia
            </h2>
            <p className="text-xl text-white/90 mb-8 leading-relaxed">
              En Obrador Pomodoro, creemos que la excelencia no solo está en el plato, 
              sino en cada momento que pasás con nosotros. Nuestro equipo, liderado por 
              profesionales como Facundo, está dedicado a brindarte una experiencia única.
            </p>

            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Heart size={24} />
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">Atención Cercana</h3>
                  <p className="text-white/80">
                    Tratamos a cada cliente como parte de nuestra familia italiana
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Clock size={24} />
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">Servicio Rápido</h3>
                  <p className="text-white/80">
                    Espera promedio menor a 10 minutos - valoramos tu tiempo
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Award size={24} />
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">Altamente Valorado</h3>
                  <p className="text-white/80">
                    La atención es lo que más destacan nuestros clientes
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-8 p-6 bg-white/10 backdrop-blur-sm rounded-xl border border-white/20">
              <p className="text-lg italic">
                "La atención fue lo mejor. Facundo y todo el equipo nos hicieron sentir 
                como en casa. ¡Volvemos seguro!"
              </p>
              <p className="mt-2 text-sm text-white/70">- Cliente frecuente</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Attention;
